import React from 'react';
import styled from 'styled-components';
import indents from '../../../../../constants/js/indents.js';
import colors from '../../../../../constants/js/colors.js';
const constantPadding = {
  h56: indents.indentS,
  h48: indents.indent12
};
const StyledContainer = styled.div.withConfig({
  componentId: "index__sc-b6vtrv-0"
})(["display:flex;justify-content:center;align-items:center;padding:", ";fill:currentColor;color:", ";"], ({
  size
}) => constantPadding[size], colors.majorGray);
export const IconContainer = ({
  children,
  size
}) => {
  return React.createElement(StyledContainer, {
    size: size
  }, children);
};